import React from "react";

// 🔹 Reusable Try It Button
export default function TryItButton() {
  return (
    <div className="tutorial-container">
      <h1>JS OOPs Reference</h1>
      <p>
        This tutorial explains the concept of JS OOPs Reference in JavaScript
        OOPs.
      </p>
    </div>
  );
}
